// extracted by mini-css-extract-plugin
export default {"no-products-message":"NoItemsMessage_no-products-message__fr8bf"};